// @flow
import React from 'react';

import Content from './Content';

const Teams = props => {
  return <Content {...props} />;
};

export default Teams;
